// import PropTypes from 'prop-types';
import React from 'react';
import { AdviceLandingPage } from '../../../components/Community/Advice/AdviceLandingPage';
import Layout from '../../../components/Layout/LayoutV2/Layout';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

const Advice = (props) => {
    const { contents, topicSelected, page } = props;
    return (
        <div className="advice-page">
            <SnowplowPageViewTracker
                pageSection={PAGE_VIEW_SECTIONS.ADVICE_LANDING}
                pageType={PAGE_VIEW_TYPES.COLLECTION}
            />
            <Layout {...props}>
                <AdviceLandingPage
                    contents={contents}
                    topicSelected={topicSelected}
                    page={page}
                />
            </Layout>
        </div>
    );
};

export default Advice;
